/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_MY_PROFILE = gql`
  query Org {
    getMyProfile {
      vuid
      userId
      firstName
      middleName
      lastName
      fullName
      emailVerified
      phoneVerified
      image
      accountStatus
      nationality
      orgRoles {
        orgId {
          orgId
          name
        }
        role {
          name
          uuid
        }
      }
      primaryContactNo

      createdAt
      org {
        status
        country
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          country
          state
          zipcode
        }
        description
        email
        logo
        name
        orgId
        primaryContactNo
        socialLinks
        website
        tradingName
        trn
        type
        registrationNo
        natureOfBusiness
        incorporationDate
        directors {
          firstName
          lastName
          fullName
        }
        branches {
          name
        }
        subsidiaries {
          name
        }
        documents {
          type
          src
          name
          fileType
          expiry
        }
      }
      trn
      email
    }
  }
`;
